module.exports = __webpack_public_path__ + "02c9a47ab8dd507017b0e11ade447639.svg";